/**
 * What things cost, against what they did: almost everything 30% cheaper (players asked, 2026-10-28). Shops, food,
 * tickets, rent, homes, cars, aircraft, flights, Jumbo; not wages, earnings, gifts, fines already scaled to a price,
 * or the real-money packs. character.ts localPrice applies it; the catalogues with their own numbers apply `cheaper`.
 * (No imports: catalogues use it as their modules load.)
 */
export const PRICES = 0.7;
/** a price at PRICES, rounded to `to` (never below it) */
export const cheaper = (n: number, to = 100) => (n <= 0 ? n : Math.max(to, Math.round((n * PRICES) / to) * to));
